import { render } from "./InfiniteScrollLoader.vue?vue&type=template&id=aec250bc&scoped=true"
import script from "./InfiniteScrollLoader.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollLoader.vue?vue&type=script&lang=js"

import "./InfiniteScrollLoader.vue?vue&type=style&index=0&id=aec250bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec250bc"]])

export default __exports__